import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { GenerateRequest } from 'types'

interface Variables {
  workspaceId: number
  projectId: string
  postId: number
  postAmount: number
  campaignId: number
  sourceVisualElementId: number
}

const createDesign = async ({
  workspaceId,
  projectId,
  postId,
  postAmount,
  campaignId,
  sourceVisualElementId,
}: Variables) => {
  const res = await sendToApi(`/w/${workspaceId}/best_performing_platform_posts/${postId}/generate_design`, {
    method: 'POST',
    body: {
      project_id: projectId,
      post_amount: postAmount,
      campaign_id: campaignId,
      source_visual_element_id: sourceVisualElementId,
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data.request
}

export const useCreateDesignSync = () => {
  return useMutation(
    async (vars: Variables) => {
      const request = await createDesign(vars)

      let requestResponse: GenerateRequest | undefined
      let interval = 500
      do {
        const res = await sendToApi<{ request: GenerateRequest }>(`/ai_suggestion_requests/${request.id}`)

        if (res.type !== SUCCESS_RESPONSE_TYPE) {
          throw new Error()
        }

        requestResponse = res.data.request

        if (requestResponse?.status === 'failed') {
          throw new Error('Failed to generate design')
        }

        await new Promise((resolve) => {
          setTimeout(resolve, interval)
        })
      } while (!['successful', 'aborted', 'failed'].includes(requestResponse?.status))

      return requestResponse
    },
    {
      mutationKey: 'createDesign',
    },
  )
}
